import {Component, HostListener} from '@angular/core';
import {BaseComponent} from './base-component';

@Component({
  template: ''
})
export class CanDeactivateComponent extends BaseComponent {
  canDeactivateMessage = 'unsavedChangesMessage';

  canDeactivate(): boolean {
    throw new Error('Function canDeactivate is not implemented!');
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }
}
